import type { ReactNode } from 'react';
import { useAuth } from './AuthProvider';

export function ProtectedRoute({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div role="status">Loading your session…</div>;
  if (!user) return <>{fallback ?? <p>You need to log in to view this page.</p>}</>;
  return <>{children}</>;
}
